import { pdfjs } from 'react-pdf';
import { DEFAULT_FIRST_PAGE, PageTypes } from '../../../../types';

export const loadPdfWorker = (version) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
};

export const getLeftAndRightPages = (pagesToDisplay: any[]) => {
  const leftPage = pagesToDisplay[0]?.pageNumber ?? DEFAULT_FIRST_PAGE[PageTypes.Pdf];
  const rightPage = pagesToDisplay[1]?.pageNumber;

  return {
    leftPage: leftPage === 0 || leftPage === -1 ? null : leftPage,
    rightPage,
  };
};

export const getPageNumber = (page: 'leftPage' | 'rightPage', pagesToDisplay: any[]) =>
  getLeftAndRightPages(pagesToDisplay)[page];

export const getActivePages = (currentPage: number, pagesToDisplay: any[]) => [
  currentPage === DEFAULT_FIRST_PAGE[PageTypes.Pdf]
    ? currentPage
    : getPageNumber('leftPage', pagesToDisplay),
  currentPage === DEFAULT_FIRST_PAGE[PageTypes.Pdf]
    ? null
    : getPageNumber('rightPage', pagesToDisplay),
];
